import { type AuthSession } from "@aws-amplify/auth";
import { type ParsedLocation, redirect } from "@tanstack/react-router";

export const isAuthenticated = ({ session }: { session?: AuthSession }) => {
  return !!session?.tokens?.idToken?.toString();
};

export const redirectIfNotAuthenticated = ({
  session,
  location,
}: {
  session?: AuthSession;
  location: ParsedLocation;
}) => {
  if (!isAuthenticated({ session })) {
    throw redirect({
      to: "/login",
      search: {
        redirect: location.href,
      },
    });
  }
};

export const redirectIfAuthenticated = ({
  session,
  location,
}: {
  session?: AuthSession;
  location: ParsedLocation;
}) => {
  if (!isAuthenticated({ session })) {
    return;
  }

  const next = new URLSearchParams(location.searchStr).get("redirect")?.trim();
  if (next) {
    throw redirect({ to: next });
  }

  throw redirect({ to: "/" });
};
